<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [showBack]="true"></prox-main>
<ng-template #bodyTemplate>
  <p-dialog header="Please wait..." [(visible)]="importRunning" [modal]="true" [style]="{ width: '50vw' }"
    [draggable]="false" [resizable]="false" [closable]="false">
    <p class="m-0">
      Import process is running...
    </p>
  </p-dialog>
  <div class="flex flex-row">
    <div class="flex mb-2">
      <p-button (click)="getTemplate()" [disabled]="inFlight" size="large" label="Download Template"
        icon="fa-solid fa-download"></p-button>
    </div>
    <div class="flex ml-2 mb-2">
      <p-fileUpload mode="basic" name="file[]" chooseLabel="Upload Account Users" [customUpload]="true"
        accept="{{acceptedFiles}}" invalidFileTypeMessageDetail="Allowed file types: {{acceptedFiles}}"
        [maxFileSize]="1000000" [auto]="true" [disabled]="inFlight"
        (uploadHandler)="onLoad($event)"></p-fileUpload>
    </div>
    <div class="flex ml-2 mb-2">
      <p-button (click)="onSubmit()" [disabled]="submitDisabled()" size="large" label="Submit"
        icon="fa-solid fa-upload"></p-button>
    </div>
    <!-- Appears only once a save has been attempted: until then the grid is a plan, not a result. -->
    <div class="flex ml-2 mb-2" *ngIf="hasResults">
      <p-button (click)="onExportResults()" [disabled]="inFlight" size="large" label="Export to Excel"
        icon="fa-solid fa-file-excel"></p-button>
    </div>
  </div>

  <!-- Accounts that map no codes get the grid on its own: no splitter, no empty panel. -->
  <div *ngIf="!includeCodes" class="flex w-full grow py-2">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="importUsers" [rowClassRules]="rowClassRules">
    </prox-ag-grid>
  </div>

  <p-splitter *ngIf="includeCodes" class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
    <ng-template pTemplate>
      <div class="py-2 w-full h-full">
        <prox-ag-grid [gridOptions]="gridOptions" [rowData]="importUsers" [rowClassRules]="rowClassRules">
        </prox-ag-grid>
      </div>
    </ng-template>
    <!-- One code grid per dimension the account actually uses. The guards are on plain divs,
         not on the pTemplate: PrimeNG reads its panel templates directly, so an *ngIf on the
         template itself never takes effect. -->
    <ng-template pTemplate>
      <div class="flex flex-row w-full h-full gap-2 pb-7">
        <div *ngIf="includeShippingCodes" class="flex flex-col w-full h-full">
          <div class="flex pb-2">
            <label class="pt-2 mb-1 pr-3 pl-2 font-bold">Attach Shipping Groups to Codes</label>
          </div>
          <prox-ag-grid [gridOptions]="shippingCodesGridOptions" [rowData]="shippingCodes">
          </prox-ag-grid>
        </div>
        <div *ngIf="includeProgramCodes" class="flex flex-col w-full h-full">
          <div class="flex pb-2">
            <label class="pt-2 mb-1 pr-3 pl-2 font-bold">Attach Program Groups to Codes</label>
          </div>
          <prox-ag-grid [gridOptions]="programCodesGridOptions" [rowData]="programCodes">
          </prox-ag-grid>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
